import PageHeroSection from '@components/ui/page-hero-section';
import ImpressumPageContent from './impressum-page-content';
import { useRouteLang } from 'src/hooks/use-route-lang';

export default function ImpressumPage() {
  const lang = useRouteLang();

  return (
    <>
      {/*<PageHeroSection heroTitle="Impressum" lang={lang} />*/}
      <ImpressumPageContent lang={lang} />
      {/*<DownloadApps lang={lang} />*/}
    </>
  );
}
